import NOAATides from '../services/NOAATides'
import moment from '../lib/moment'

import {
  SELECT_DATE,
  SELECT_TIDE_STATION,
  CLEAR_SELECTED_TIDE_STATION,
  UPDATE_NOW_MOMENT,
  SET_PAGE_VIEW,
  UPDATE_LOCATION_SEARCH,
  OPEN_DATE_PICKER,
  CLOSE_DATE_PICKER,
} from '../actions'

import {
  fetchTidesIfNeeded
} from '../actions/tidesActions'

import {
  tideStationSelector,
  dateSelector,
  datePickerIsOpenSelector,
} from '../reducers/uiReducer'


export function selectDate(date, shouldFetch=true) {
  const action = {
    type: SELECT_DATE,
    date: moment(date)
  }
  return selectAndFetch(action, shouldFetch)
}

export function selectNextDate(n, duration) {
  return function(dispatch, getState) {
    const currentDate = dateSelector(getState())
    const nextDate = currentDate.clone().add(n, duration).startOf(duration)
    return dispatch(selectDate(nextDate))
  }
}

export function selectTideStation(stationOrStationId, shouldFetch=true) {
  // If argument is a stationId string, then use it to find a station.
  // Otherwise, argument is a station.
  const station = (typeof(stationOrStationId) === 'string') ? (
    NOAATides.getStationById(stationOrStationId)
  ) : (
    stationOrStationId
  )

  const action = {
    type: SELECT_TIDE_STATION,
    station
  }
  return selectAndFetch(action, shouldFetch)
}

export function clearSelectedTideStation() {
  return {
    type: CLEAR_SELECTED_TIDE_STATION
  }
}

function selectAndFetch(action, shouldFetch) {
  if (shouldFetch) {
    return function(dispatch) {
      dispatch(action)
      return dispatch(fetchSelected())
    }
  }
  else {
    return action
  }
}

export function fetchSelected() {
  return function(dispatch, getState) {
    const state = getState()

    const stationId = tideStationSelector(state).stationId

    const date = dateSelector(state)
    const range = moment.range(
      date.clone().subtract(1, 'month').startOf('month'),
      date.clone().add(2, 'month').startOf('month')
    )

    return dispatch(fetchTidesIfNeeded(stationId, range))
  }
}

export function updateLocationSearch(locationSearchProps) {
  return {
    type: UPDATE_LOCATION_SEARCH,
    locationSearchProps
  }
}
export function clearLocationSearch() {
  return {
    type: UPDATE_LOCATION_SEARCH,
    locationSearchProps: { query: '' }
  }
}

export function setPageView(pageView) {
  return {
    type: SET_PAGE_VIEW,
    pageView
  }
}

export function updateNowMoment() {
  return {
    type: UPDATE_NOW_MOMENT,
    now: moment()
  }
}

// Schedule the updateNowMoment action to dispatch whenever the
// system minute changes. Should only be used once on app init.
let timeoutToken = null
export function startUpdatingNowMomentEveryMinute() {
  clearTimeout(timeoutToken)

  const updateAndRepeat = (dispatch) => {
    // Dispatch action
    dispatch(updateNowMoment())

    // Calculate miliseconds until next minute change
    const now = moment()
    const next = now.clone().add(1, 'minute').startOf('minute')
    const timeToNext = next.diff(now) + 50

    // Schedule next dispatch
    timeoutToken = setTimeout(
      function() {
        updateAndRepeat(dispatch)
      },
      timeToNext
    )

    return Promise.resolve()
  }

  return updateAndRepeat
}



export function openDatePicker() {
  return {
    type: OPEN_DATE_PICKER
  }
}
export function closeDatePicker() {
  return {
    type: CLOSE_DATE_PICKER
  }
}
export function toggleDatePicker() {
  return function(dispatch, getState) {
    const isOpen = datePickerIsOpenSelector(getState())

    if (isOpen)
      return dispatch(closeDatePicker())
    else
      return dispatch(openDatePicker())
  }
}



// WEBPACK FOOTER //
// ./src/actions/uiActions.js